export default "__VITE_ASSET__DqSoouD2__"